import { isExecutive, isOrganizationAdmin, isTeamManager } from "@packages/core/session/roles.ts";
import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import { useEnvironmentVariables, useFeatureFlag } from "@squide/firefly";
import { useEffect } from "react";
import { shutdownIntercom, startIntercom } from "./startIntercom.ts";

export interface IntercomMessengerProps {
    identityToken?: string;
}

export function IntercomMessenger({ identityToken }: IntercomMessengerProps) {
    const { intercomAppId } = useEnvironmentVariables();
    const isIntercomMessengerEnabled = useFeatureFlag("intercom-messenger", false);
    const session = useSession();

    useEffect(() => {
        if (!isIntercomMessengerEnabled) {
            shutdownIntercom();

            return;
        }

        if (!intercomAppId || !session) {
            return;
        }

        const isAdmin = isOrganizationAdmin(session);
        const isExecutiveManager = isExecutive(session);
        const isManager = isTeamManager(session);

        startIntercom({
            app_id: intercomAppId,
            name: session.firstName,
            email: session.email,
            user_id: session.memberId,
            user_hash: identityToken,
            isOrganizationAdmin: isAdmin,
            isExecutiveManager,
            isTeamManager: isManager,
            isMember: !isAdmin && !isExecutiveManager && !isManager,
            preferredLanguage: session.preferredLanguage
        });
    }, [isIntercomMessengerEnabled, intercomAppId, session, identityToken]);

    return null;
}
